import Vue from 'vue'
import Router from 'vue-router'
import Sessions from '@/api/sessions'
import APIReferrals from '@/api/referrals'
import Main from '@/pages/main'
import SignupType from '@/pages/signup-type'
import Verify from '@/pages/verify'
import SignupJobseeker1 from '@/pages/jobseeker-signup-1'
import SignupJobseeker2 from '@/pages/jobseeker-signup-2'
import SignupHirer from '@/pages/hirer-signup'
import JobsList from '@/pages/jobs-list'
import Job from '@/pages/job'
import Wallet from '@/pages/wallet'
import Profile from '@/pages/profile'
import Magic from '@/pages/magic'
import Jobseekers from '@/pages/jobseekers'
import JobseekerProfile from '@/pages/jobseekers/profile'
import Messages from '@/pages/messaging/messages'
import UserReferral from '@/pages/referrals/user'
import EmailReferral from '@/pages/referrals/email'
import Referrals from '@/pages/referrals/referrals'
import JobReferrals from '@/pages/referrals/job-referrals'
import AdminIndex from '@/pages/admin/index'
import AdminJobs from '@/pages/admin/jobs'
import AdminApplications from '@/pages/admin/applications'
import AdminCompanies from '../pages/admin/companies'
import AdminJobsApplication from '@/pages/admin/job-applications'
import AdminHireres from '@/pages/admin/hirers'
import Settings from '@/pages/settings'
import EosAccountSettings from '@/pages/settings/eos-account'
import YotiKyc from '@/pages/settings/yoti-kyc'
import HirerPage from '../pages/hirer-page'
import MagicWallet from '@/pages/magic-wallet'
import Companies from '../pages/companies'
import Widget from '@/api/widget'
import DaoCommunity from '../pages/dao-community.vue'
import Proposal from '../pages/proposal.vue'

import store from '../store'
import {Login, Signup, JobsListWidget} from '../helpers/lazy-routes'
import {roles} from '../constants/general-constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '',
    name: 'Main',
    component: Main,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/jobs/:ecoSystem/:type',
    name: 'JobsListSearch',
    component: JobsList,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/signup',
    name: 'Signup',
    component: Signup(),
    meta: {
      authType: 'unauth',
      hidesNavbar: true
    }
  }, {
    path: '/signup-type',
    name: 'SignupType',
    component: SignupType,
    meta: {
      authType: 'unauth',
      hidesNavbar: true,
      hideWallet: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: Login(),
    meta: {
      authType: 'unauth',
      hidesNavbar: true
    }
  }, {
    path: '/verify',
    name: 'Verify',
    component: Verify,
    meta: {
      authType: 'any'
    }
  }, {
    path: '/signup/jobseeker/1',
    name: 'Signup Jobseeker 1',
    component: SignupJobseeker1,
    meta: {
      authType: 'jobseeker',
      hidesNavbar: true,
      hideWallet: true
    }
  }, {
    path: '/signup/jobseeker/2',
    name: 'Signup Jobseeker 2',
    component: SignupJobseeker2,
    meta: {
      authType: 'jobseeker',
      hidesNavbar: true,
      hideWallet: true
    }
  }, {
    path: '/signup/hirer',
    name: 'Signup Hirer',
    component: SignupHirer,
    meta: {
      authType: 'jobseeker',
      hidesNavbar: true,
      hideWallet: true
    }
  }, {
    path: '/jobs',
    name: 'JobsList',
    component: JobsList,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/dao-community',
    name: 'DaoCommunity',
    component: DaoCommunity,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/proposal/:id',
    name: 'ProposalPage',
    component: Proposal,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/widget/:id',
    name: 'JobsListWidget',
    component: JobsListWidget(),
    meta: {
      authType: 'unauth',
      widgetMode: true,
      disableIntercom: true // TODO: not working in widget route
    }
  }, {
    path: '/widget/hirer/:id',
    name: 'WidgetHirerDetailPage',
    component: HirerPage,
    meta: {
      authType: 'auth',
      widgetMode: true,
      disableIntercom: true
    }
  }, {
    path: '/widget/jobs/:id',
    name: 'WidgetJobsApply',
    component: Job,
    meta: {
      authType: 'auth',
      widgetMode: true,
      disableIntercom: true
    }
  }, {
    path: '/stacks',
    name: 'Stacks',
    component: MagicWallet,
    meta: {
      authType: 'auth'
    }
  },
  {
    path: '/stacks',
    name: 'StacksJobsList',
    component: JobsList,
    meta: {
      authType: 'auth',
      stacks: true
    }
  },
  {
    path: '/companies',
    name: 'Companies',
    component: Companies,
    meta: {
      authType: 'auth'
    }
  },
  {
    path: '/jobs/:id',
    name: 'JobsApply',
    component: Job,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/wallet',
    name: 'Wallet',
    component: Wallet,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/me',
    name: 'Profile',
    component: Profile,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    redirect: { name: 'eosAccount' },
    meta: {
      authType: 'auth'
    },
    children: [
      {
        path: 'eos-account',
        name: 'eosAccount',
        component: EosAccountSettings,
        meta: { authType: 'auth' }
      },
      {
        path: 'kyc',
        name: 'settingKyc',
        component: YotiKyc,
        meta: { authType: 'auth' }
      }
    ]
  }, {
    path: '/magic',
    name: 'Magic',
    component: Magic,
    meta: {
      authType: 'unauth'
    }
  }, {
    path: '/applications/widget/login/:id',
    name: 'Magic',
    component: Magic,
    meta: {
      authType: 'unauth'
    }
  }, {
    path: '/jobseekers',
    name: 'Jobseekers',
    component: Jobseekers,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/jobseekers/:id',
    name: 'Jobseeker Profile',
    component: JobseekerProfile,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/hirer/:id',
    name: 'HirerDetailPage',
    component: HirerPage,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/messages',
    name: 'Messages',
    component: Messages,
    meta: {
      authType: 'auth',
      disableIntercom: true
    }
  }, {
    path: '/messages/:id',
    name: 'MessagesDetail',
    component: Messages,
    meta: {
      authType: 'auth',
      disableIntercom: true
    }
  }, {
    path: '/referrals/user/:token',
    name: 'Referrals Confirm',
    component: UserReferral,
    meta: {
      authType: 'auth',
      hideWallet: true
    }
  }, {
    path: '/referrals/email/:token',
    name: 'Email Referrals Confirm',
    component: EmailReferral,
    meta: {
      authType: 'any',
      hideWallet: true
    }
  }, {
    path: '/referrals',
    name: 'Referrals',
    component: Referrals,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/referrals/job/:jobId',
    name: 'JobReferrals',
    component: JobReferrals,
    meta: {
      authType: 'auth'
    }
  }, {
    path: '/admin',
    name: 'AdminIndex',
    component: AdminIndex,
    redirect: { name: 'AdminJobs' },
    meta: {
      authType: 'admin'
    },
    children: [{
      path: 'companies',
      name: 'AdminCompanies',
      component: AdminCompanies,
      meta: { authType: 'admin' }
    }, {
      name: 'AdminJobs',
      path: 'jobs',
      component: AdminJobs,
      meta: { authType: 'admin' }
    }, {
      name: 'AdminCreateJobs',
      path: 'jobs/createJob',
      component: AdminJobs,
      meta: { authType: 'admin' }
    },
    {
      name: 'AdminApplications',
      path: 'applications',
      component: AdminApplications,
      meta: { authType: 'admin' }
    }, {
      name: 'AdminJobApplicationsMagic',
      path: 'applications/:id/:appId?',
      component: AdminJobsApplication,
      meta: { authType: 'admin' }
    }, {
      name: 'AdminHirersPage',
      path: 'hirers',
      component: AdminHireres,
      meta: { authType: 'admin' }
    }]
  }]
})

router.beforeEach(async (to, from, next) => {
  const type = to.meta.authType

  // for referral link
  if (to.fullPath.startsWith('/referral/s/')) {
    const arrURIs = to.fullPath.split('/')
    const slug = arrURIs[3]
    let res
    try {
      res = await APIReferrals.consumeReferral({ slug })
      router.replace({ name: 'JobsApply', params: { id: res.jobId } })
    } catch (error) {
      console.error('referral', error)
      router.replace({ name: 'Main' })
    }
  }

  if (type === 'any') { return next() }
  try {
    await Sessions.checkAuth(type)
    return next()
  } catch (error) {
    if (to.fullPath.startsWith('/jobs')) {
      return next()
    }
  }
  return next()
})
// router.beforeEach(async (to, from, next) => {
//   try {
//     if (store.state.users.user) {
//       const profileCompleted = await Sessions.checkProfileCompletion()
//       if (!profileCompleted) {
//         return next({ name: 'SignupType' })
//       } else {
//         return next()
//       }
//     }
//     return next()
//   } catch (e) {
//     return next()
//   }
// })
router.beforeEach(async (to, from, next) => {
  try {
    if (to.name === 'Login' || to.name === 'Signup') {
      await Sessions.checkAuth('auth')
      return next({ name: 'Main' })
    }
    return next()
  } catch (e) {
    return next()
  }
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to.name === 'Referrals') {
      await Sessions.checkAuth('auth')
      if (store.state.users.user.profile === roles.hirer) {
        return next({ name: 'Main' })
      }
    }
    return next()
  } catch (e) {
    return next()
  }
})

router.beforeEach(async (to, from, next) => {
  try {
    const token = localStorage.getItem('widget_token')
    const profileStatus = localStorage.getItem('profile_status')
    if (to.name === 'AdminJobApplicationsMagic' || to.name === 'MessagesDetail') {
      await Sessions.checkAuth('auth')
      return next()
    }
    if (token && profileStatus) {
      if ((to.name !== 'Signup Jobseeker 1' && to.name !== 'Signup Jobseeker 2') && profileStatus === 'signup') {
        const res = await Widget.widgetLogin(token)
        if (res.action === 'signup') {
          return next({ name: 'Signup Jobseeker 1' })
        } else {
          localStorage.removeItem('widget_token')
          localStorage.removeItem('profile_status')
          return next()
        }
      }
    }
    return next()
  } catch (e) {
    return next({ name: 'Login' })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js